import { EthAddressType } from 'multirpc-sdk';

import { useAppSelector } from 'store/useAppSelector';

import {
  selectAssociatedAccountsLoaded,
  selectAuth0UserAccount,
  selectGithubUserAccount,
  selectGoogleUserAccount,
  selectIsUserInitialized,
  selectIsUserInitializing,
  selectIsWeb3OAuth,
  selectUserAddress,
  selectUserAddressType,
  selectUserETHAddressesLoaded,
  selectUserEmail,
  selectUserNickname,
  selectWeb3UserAccount,
  selectSlackUserAccount,
  selectXUserAccount,
  selectMicrosoftUserAccount,
  selectTelegramUserAccount,
} from '../store/selectors';

export const useUser = () => {
  const address = useAppSelector(selectUserAddress);
  const addressType = useAppSelector(selectUserAddressType);
  const associatedAccountsLoaded = useAppSelector(
    selectAssociatedAccountsLoaded,
  );
  const email = useAppSelector(selectUserEmail);
  const githubAccount = useAppSelector(selectGithubUserAccount);
  const googleAccount = useAppSelector(selectGoogleUserAccount);
  const auth0Account = useAppSelector(selectAuth0UserAccount);
  const microsoftAccount = useAppSelector(selectMicrosoftUserAccount);
  const telegramAccount = useAppSelector(selectTelegramUserAccount);
  const slackAccount = useAppSelector(selectSlackUserAccount);
  const xAccount = useAppSelector(selectXUserAccount);
  const isUserInitialized = useAppSelector(selectIsUserInitialized);
  const isUserInitializing = useAppSelector(selectIsUserInitializing);
  const isWeb3OAuth = useAppSelector(selectIsWeb3OAuth);
  const nickname = useAppSelector(selectUserNickname);
  const userETHAddressesLoaded = useAppSelector(selectUserETHAddressesLoaded);
  const web3Account = useAppSelector(selectWeb3UserAccount);
  const isSyntheticAddress = addressType === EthAddressType.Generated;

  return {
    address,
    addressType,
    associatedAccountsLoaded,
    auth0Account,
    email,
    githubAccount,
    googleAccount,
    slackAccount,
    xAccount,
    isSyntheticAddress,
    isUserInitialized,
    isUserInitializing,
    isWeb3OAuth,
    nickname,
    userETHAddressesLoaded,
    web3Account,
    microsoftAccount,
    telegramAccount,
  };
};
